// context/ApiContext/apiReducer.js
export const initialState = {
  credentials: {
    userId: '',
    apiKey: ''
  },
  uplynkCentral: {
    data: {
            "jobStates": [
                // {
                //     "state": "waiting",
                //     "progress": "",
                //     "progress_percent": 0,
                //     "timestamp": "2025-03-10T20:08:03.679Z",
                //     "attempt": 1
                // },
                // {
                //     "state": "assigned",
                //     "progress": "Downloading source media",
                //     "progress_percent": 0,
                //     "timestamp": "2025-03-10T20:08:09.016Z",
                //     "attempt": 2
                // },
                // {
                //     "state": "assigned",
                //     "progress": "Downloading source media",
                //     "progress_percent": 0,
                //     "timestamp": "2025-03-10T20:08:14.082Z",
                //     "attempt": 3
                // },
                // {
                //     "state": "assigned",
                //     "progress": "Slicing",
                //     "progress_percent": 0,
                //     "timestamp": "2025-03-10T20:08:19.460Z",
                //     "attempt": 4
                // },
                // {
                //     "state": "assigned",
                //     "progress": "Slicing",
                //     "progress_percent": 0,
                //     "timestamp": "2025-03-10T20:08:24.521Z",
                //     "attempt": 5
                // },
              //   {
              //       "state": "assigned",
              //       "progress": "Slicing",
              //       "progress_percent": 0,
              //       "timestamp": "2025-03-10T20:08:29.908Z",
              //       "attempt": 6
              //   },
              //   {
              //       "state": "assigned",
              //       "progress": "Slicing",
              //       "progress_percent": 82,
              //       "timestamp": "2025-03-10T20:08:34.980Z",
              //       "attempt": 7
              //   },
              //   {
              //       "state": "done",
              //       "progress": "Finished successfully",
              //       "progress_percent": 100,
              //       "timestamp": "2025-03-10T20:08:40.044Z",
              //       "attempt": 8
              //   },
              //   {
              //     "state": "waiting",
              //     "progress": "",
              //     "progress_percent": 0,
              //     "timestamp": "2025-03-10T20:08:03.679Z",
              //     "attempt": 1
              // },
              // {
              //     "state": "assigned",
              //     "progress": "Downloading source media",
              //     "progress_percent": 0,
              //     "timestamp": "2025-03-10T20:08:09.016Z",
              //     "attempt": 2
              // },
              // {
              //     "state": "assigned",
              //     "progress": "Downloading source media",
              //     "progress_percent": 0,
              //     "timestamp": "2025-03-10T20:08:14.082Z",
              //     "attempt": 3
              // }
            ],
    },
    status: 'idle',
    error: null
  },
  apiInterval: 3000,
  moduleNodes: {}, // Keyed by nodeId
  executionOrder: [], // Array of nodeIds in execution order
  executionStatus: {
    isExecuting: false,
    currentNodeId: null,
    currentEndpointIndex: null,
    errors: {},
    responses: {}
  },
  sharedParams: {
    playerURL: null,
    isPlayerURLReady: false
  },
  processingStates: {
    isCloudProcessRunning: false
  }
};

export const ActionTypes = {
  SET_CREDENTIALS: 'SET_CREDENTIALS',
  SET_API_INTERVAL: 'SET_API_INTERVAL',
  SET_UPLYNK_CENTRAL: 'SET_UPLYNK_CENTRAL',
  UPDATE_UPLYNK_CENTRAL: 'UPDATE_UPLYNK_CENTRAL',
  APPEND_UPLYNK_JOB_STATE: 'APPEND_UPLYNK_JOB_STATE',
  CLEAR_UPLYNK_CENTRAL: 'CLEAR_UPLYNK_CENTRAL',
  REGISTER_MODULE: 'REGISTER_MODULE',
  UPDATE_MODULE_CONFIG: 'UPDATE_MODULE_CONFIG',
  UPDATE_API_PARAMS: 'UPDATE_API_PARAMS',
  SET_EXECUTION_ORDER: 'SET_EXECUTION_ORDER',
  REORDER_EXECUTION: 'REORDER_EXECUTION',
  REMOVE_MODULE: 'REMOVE_MODULE',
  TOGGLE_MODULE_ACTIVE: 'TOGGLE_MODULE_ACTIVE',
  SET_EXECUTION_STATUS: 'SET_EXECUTION_STATUS',
  RESET_STATE: 'reset_state',
  CLEAR_QUEUE: 'clear_queue',
  UPDATE_SHARED_PARAMS: 'UPDATE_SHARED_PARAMS',
  SET_PROCESSING_STATE: 'SET_PROCESSING_STATE'
};

export const apiReducer = (state, action) => {
  switch (action.type) {
    case ActionTypes.SET_CREDENTIALS: {
      return {
        ...state,
        credentials: action.payload
      };
    };
    
    case ActionTypes.SET_API_INTERVAL: {
      return {
        ...state,
        apiInterval: action.payload
      };
    };

    case ActionTypes.SET_UPLYNK_CENTRAL: {
      return {
        ...state,
        uplynkCentral: {
          ...state.uplynkCentral,
          data: action.payload,
          status: 'success',
          error: null
        }
      };
    };

    case ActionTypes.UPDATE_UPLYNK_CENTRAL: {
      return {
        ...state,
        uplynkCentral: {
          ...state.uplynkCentral,
          data: {
            ...state.uplynkCentral.data,
            ...action.payload
          },
          status: 'success',
          error: null
        }
      };
    };


    case ActionTypes.APPEND_UPLYNK_JOB_STATE: {
      // Safely access jobStates with optional chaining
      const currentJobStates = state.uplynkCentral?.data?.jobStates || [];
      const newEntry = action.payload;
      
      // Check if this state is different from the last one
      const lastEntry = currentJobStates.length > 0 ? currentJobStates[currentJobStates.length - 1] : null;
      const shouldAppend = !lastEntry || lastEntry.state !== newEntry.state;
      
      return {
        ...state,
        uplynkCentral: {
          ...state.uplynkCentral,
          data: {
            ...state.uplynkCentral.data,
            // jobStates: shouldAppend 
            //   ? [...currentJobStates, newEntry]
            //   : currentJobStates
            jobStates: [...currentJobStates, action.payload]
          },
          status: 'success',
          error: null
        }
      };
    };
    
    

    case ActionTypes.CLEAR_UPLYNK_CENTRAL: {
      return {
        ...state,
        uplynkCentral: {
          data: {
            "jobStates": []
          },
          status: 'idle',
          error: null
        }
      };
    };
        
    case ActionTypes.REGISTER_MODULE: {
      const { nodeId, moduleConfig, label } = action.payload;
      
      // Add node to execution order if it's not already there
      const newExecutionOrder = state.executionOrder.includes(nodeId) 
        ? state.executionOrder 
        : [...state.executionOrder, nodeId];
      
      return {
        ...state,
        moduleNodes: {
          ...state.moduleNodes,
          [nodeId]: {
            ...moduleConfig,
            label: label || ''
          }
        },
        executionOrder: newExecutionOrder
      };
    };
    

    case ActionTypes.UPDATE_MODULE_CONFIG: {
      const { nodeId, endpoints, validation } = action.payload;
      
      // Only update if the node already exists
      if (!state.moduleNodes[nodeId]) {
        return state;
      }
      
      // Calculate new readyState if validation was provided
      const readyState = validation 
        ? validation.isValid 
        : state.moduleNodes[nodeId].readyState || false;
      
      return {
        ...state,
        moduleNodes: {
          ...state.moduleNodes,
          [nodeId]: {
            ...state.moduleNodes[nodeId], // Preserve existing values
            ...endpoints,                 // Update with new endpoints
            readyState,                   // Update readyState based on validation
            activeState: readyState
          }
        }
      };
    };

    case ActionTypes.UPDATE_API_PARAMS: {
      const { nodeId, endpointIndex, params } = action.payload;
      
      // Only update if the node and endpoint exist
      if (!state.moduleNodes[nodeId] || 
          !state.moduleNodes[nodeId].apiObject || 
          !state.moduleNodes[nodeId].apiObject[endpointIndex]) {
        return state;
      }
      
      const updatedApiObject = [...state.moduleNodes[nodeId].apiObject];
      updatedApiObject[endpointIndex] = {
        ...updatedApiObject[endpointIndex],
        params: {
          ...updatedApiObject[endpointIndex].params,
          ...params
        }
      };
      
      return {
        ...state,
        moduleNodes: {
          ...state.moduleNodes,
          [nodeId]: {
            ...state.moduleNodes[nodeId],
            apiObject: updatedApiObject
          }
        }
      };
    };

    case ActionTypes.SET_EXECUTION_ORDER: {
      // Ensure only registered nodes are in the execution order
      const validNodeIds = action.payload.filter(nodeId => 
        state.moduleNodes[nodeId] !== undefined
      );
      
      return {
        ...state,
        executionOrder: validNodeIds
      };
    };

    case ActionTypes.REORDER_EXECUTION: {
      const { nodeId, newPosition } = action.payload;
      
      // If node isn't in the current execution order, don't change anything
      if (!state.executionOrder.includes(nodeId)) {
        return state;
      }
      
      // Create a new array without the nodeId
      const filteredOrder = state.executionOrder.filter(id => id !== nodeId);
      
      // Insert the nodeId at the new position
      const clamped = Math.max(0, Math.min(filteredOrder.length, newPosition));
      const newOrder = [
        ...filteredOrder.slice(0, clamped),
        nodeId,
        ...filteredOrder.slice(clamped)
      ];
      
      return {
        ...state,
        executionOrder: newOrder
      };
    };

    case ActionTypes.REMOVE_MODULE: {
      const nodeId = action.payload;
      
      // Create a copy of moduleNodes without the specified node
      const { [nodeId]: removed, ...remainingNodes } = state.moduleNodes;
      
      // Remove from execution order
      const newExecutionOrder = state.executionOrder.filter(id => id !== nodeId);
      
      // Remove from execution status if present
      const newResponses = { ...state.executionStatus.responses };
      if (newResponses[nodeId]) {
        delete newResponses[nodeId];
      }
      
      const newErrors = { ...state.executionStatus.errors };
      if (newErrors[nodeId]) {
        delete newErrors[nodeId];
      }
      
      return {
        ...state,
        moduleNodes: remainingNodes,
        executionOrder: newExecutionOrder,
        executionStatus: {
          ...state.executionStatus,
          responses: newResponses,
          errors: newErrors
        }
      };
    };

    case ActionTypes.TOGGLE_MODULE_ACTIVE: {
      const nodeId = action.payload;
      
      // Only update if the node exists
      if (!state.moduleNodes[nodeId]) {
        return state;
      }
      
      return {
        ...state,
        moduleNodes: {
          ...state.moduleNodes,
          [nodeId]: {
            ...state.moduleNodes[nodeId],
            activeState: !state.moduleNodes[nodeId].activeState
          }
        }
      };
    }; 


    case ActionTypes.SET_EXECUTION_STATUS: {
      const { status } = action.payload;
      
      // If status is an object (from a functional update), use it directly
      if (typeof status === 'object' && status !== null) {
        return {
          ...state,
          executionStatus: {
            ...state.executionStatus,
            ...status
          }
        };
      }
      
      // Handle the original format with nodeId, endpointIndex, response
      const { nodeId, endpointIndex, response } = action.payload;
      
      let updatedResponses = { ...state.executionStatus.responses };
      let updatedErrors = { ...state.executionStatus.errors };
      
      // If we have a response, store it
      if (nodeId && response) {
        if (!updatedResponses[nodeId]) {
          updatedResponses[nodeId] = {};
        }
        
        // For error responses
        if (response.error) {
          if (!updatedErrors[nodeId]) {
            updatedErrors[nodeId] = {};
          }
          updatedErrors[nodeId][endpointIndex] = response.error;
        } 
        // For successful responses
        else {
          updatedResponses[nodeId][endpointIndex] = response;
        }
      }
    
      return {
        ...state,
        executionStatus: {
          ...state.executionStatus,
          isExecuting: status === 'executing',
          currentNodeId: status === 'executing' ? nodeId : null,
          currentEndpointIndex: status === 'executing' ? endpointIndex : null,
          errors: updatedErrors,
          responses: updatedResponses,
        }
      };
    };
    
    case ActionTypes.SET_PROCESSING_STATE: {
      const { key, value } = action.payload;
      
      return {
        ...state,
        processingStates: {
          ...state.processingStates,
          [key]: value
        }
      };
    };    

    case ActionTypes.UPDATE_SHARED_PARAMS: {
      return {
        ...state,
        sharedParams: {
          ...state.sharedParams,
          ...action.payload
        }
      };
    };
    
    case ActionTypes.RESET_STATE: {
      const freshState = JSON.parse(JSON.stringify(initialState));
      return freshState;
      // return initialState;
    }

    default:
      return state;
  }
};